<template>
  <b-row class="mt-2">
    <b-col cols="12" class="mt-4">
      <div class="titlePage mb-3">Exportação</div>
    </b-col>
    <b-col cols="12">
      <fcc-table
        striped
        hover
        :fields="fieldsExportacao"
        :items="lstExportacao"
        responsive
        :mostrarQuantidade="false"
        :actions="actionsExportacao"
        :por-page="'100'"
        pagination
      />
    </b-col>
  </b-row>
</template>
<script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      fieldsExportacao: [
        { key: 'tecnico', label: 'Técnico', sortable: true },
        { key: 'dataexportacao', label: 'Data da Exportação', sortable: true },
        { key: 'actions', label: '', thClass: 'no-print' }
      ],
      actionsExportacao: []
    }
  },
  watch: {
    desabilitaDeletar() {
      this.verificaBloqueio(this.desabilitaDeletar)
    }
  },
  props: {
    idNotificacao: String,
    lstExportacao: Array,
    desabilitaDeletar: Boolean
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.verificaBloqueio(this.desabilitaDeletar)
  },
  methods: {
    verificaBloqueio(ativa) {
      if (ativa) {
        this.actionsExportacao = [
          {
            button: true,
            funcaoButton: 'bloqueadoStatusLiberacao',
            icon: 'lock',
            tooltip: 'Bloqueado',
            objpermCodigo: store.state.permissaoMenu.editar
          }
        ]
      } else {
        this.actionsExportacao = [
          {
            button: true,
            funcaoButton: this.deletaExportacao,
            icon: 'trash-alt',
            tooltip: 'Deletar',
            objpermCodigo: store.state.permissaoMenu.executar
          }
        ]
      }
    },

    deletaExportacao() {
      this.callConfirm(`Tem certeza que deseja deletar?`, '').then(() => {
        this.carregaTexto(this.codeMensagem('C02'))
        axios
          .delete(
            this.baseUrlPublicacao + `PublicacaoGabarito/DeletarExportacao/${this.idNotificacao}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.$emit('listarExportacao')
            this.carregaTexto()
            this.callToast(this.mensagensUpdate.excluido)
          })
          .catch(this.setErrorSystem)
      })
    }
  }
}
</script>
